import { inject, Injectable } from "@angular/core";
import { Apollo, gql } from "apollo-angular";

@Injectable({
    providedIn: "root",
})
export class BackendNotAvailableService {
    private readonly apollo = inject(Apollo);

    testConnection() {
        return this.apollo.query({
            query: gql`
        query me {
          me {
            id
            __typename
          }
        }
      `,
            fetchPolicy: "no-cache",
        });
    }
}
